import React, { memo } from 'react';
import { BlockDraggable } from './BlockDraggable';
import { BlockInner } from './BlockInner';
import { ErrorBoundary } from '@web/utils';
import { BlockEditProvider, BlockSectionControls } from '../';
export var Block = memo(function (_a) {
    var id = _a.id, index = _a.index;
    return (React.createElement(ErrorBoundary, null,
        React.createElement(BlockEditProvider, { id: id },
            React.createElement(BlockDraggable, { id: id, index: index },
                React.createElement(BlockInner, { id: id })),
            React.createElement(BlockSectionControls, { index: index }))));
});
